import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import StructuredData from '@/components/base/StructuredData';
import { faqItems } from '@/mocks/comics';

const homeStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩漫在线 - 首页',
  description: '韩漫在线观看,免费漫画下拉式,漫画韩漫网址,韩漫网站。通过专属网址享受极速在线观看，免费下拉式阅读搭配智能预加载。',
  url: 'https://hanmanonline.com',
  inLanguage: 'zh-CN',
  mainEntity: {
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  },
};

export default function Home() {
  return (
    <main>
      <StructuredData data={homeStructuredData} />
      <HeroSection />
      <FeaturedComics />
      <CategorySection />
      <LatestUpdates />
      <FAQSection />
      <CTASection />
    </main>
  );
}